import React from "react";
import { FaTrash, FaArrowUp, FaInfo } from "react-icons/fa";

const QueuedVideo = ({video, socket, index}) => {

    const onRemove = () => {
        socket.emit('removeVideoFromQueue', video.queueUUID);
    }

    const sendToTop = () => {
        socket.emit('sendToTopOfQueue', video);
    }

    return (
        <div key={video.queueUUID} className='QueuedVideo'>
            <FaTrash className='RemoveVid' onClick={onRemove} style={{cursor: "pointer"}} />
            <div className='info'>
                <FaInfo class='MoveVid' />
                <p className='tooltip'>{video.queuedBy}</p>
            </div>
            {index != 0 && <FaArrowUp className='MoveVid' onClick={sendToTop} style={{cursor: "pointer"}} />}
            <table><tr>
                <td><img src={"https://img.youtube.com/vi/"+video.videoID+"/mqdefault.jpg"} height="50"/></td>
                <td><p>{video.title}</p></td>
            </tr></table>
        </div>

    )
}

export default QueuedVideo;